import React from "react";

type SignUpCTAProps = {
  children: React.ReactNode;
  onClick: () => void;
  size?: "small" | "regular" | "large";
};

export function SignUpCTA({
  children,
  onClick,
  size = "large",
}: SignUpCTAProps) {
  return (
    <button
      onClick={onClick}
      className={`
        font-semibold text-white bg-indigo-600 rounded-lg
        transform transition-all duration-300
        hover:bg-indigo-700 hover:scale-[1.02] hover:shadow-lg
        active:scale-[0.98]
        ${
          size === "large"
            ? "py-4 px-8 text-lg"
            : size === "regular"
              ? "py-3 px-6"
              : "py-2 px-4 text-sm"
        }
      `}
    >
      {children}
    </button>
  );
}
